import { Component, Input, OnInit } from "@angular/core";
import { AppComponent } from "src/app/app.component";

@Component({
  selector: 'app-new-version-dialog',
  templateUrl: './new-version-dialog.component.html',
  styleUrls: ['./new-version-dialog.component.scss']
})

export class NewVersionDialogComponent implements OnInit {

  @Input() newVersion!: string;
  @Input() oldVersion!: string;
  @Input() public app!: AppComponent;
  public displayDialog = false;
  
  ngOnInit(): void {
    this.newVersion = 'n/a'
    this.oldVersion = 'n/a';
  }

  refresh(): void {
    const u = window.location.pathname + "?rt=" + new Date().getTime();
    console.debug('refreshing using ' + u);
    window.location.href = u;
  }

}
